import React, { Component } from "react";
import GroupContract from "./groupContract";
import getGroupContract from "services/groupContract/groupContract.service";
import { connect } from "react-redux";
import { withRouter } from "utilities/withRouter";

class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.dispatch(getGroupContract());
    }
    

    render() {
        let { groupContract, groupTypes } = this.props;
        return (
            <div className="row contract-container">
                <GroupContract groupContract={groupContract?.data?.data} groupTypes={groupTypes} />
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    groupContract: state.groupContract,
    groupTypes: state.groupTypes
});

export default connect(mapStateToProps)(withRouter(Container));
export { Container };

